import { createSelector } from '@reduxjs/toolkit'

import { selectMarketYoyGrowthExpectationState } from './selectMarketYoyGrowthExpectationState'

export const selectHasMarketYoyGrowthDirtyEdits = createSelector(
  [selectMarketYoyGrowthExpectationState],
  (state) => Object.keys(state.edits).length > 0
)
